import { React, useState, useEffect } from "react";
import { MSpinner, Flex, Heading } from "@cisco/spaces-dash-lib-styleguide";
import * as PartnerDashboardService from "../../service/partner-dashboard-service";
import "./list-base.scss";
import ListApps from "../list-apps/list-apps";

function ListBase(props) {
  const { partnerDomainSetup, activationMap, mtcAppAllowed, resetList, appEdit, copyAppFn, setHideListApps, i18n } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [apps, setApps] = useState([]);

  const getApps = () => {
    setIsLoading(true);
    // PartnerDashboardService.getPartnerAppsList("all", true)
    let region = "all";
    if (partnerDomainSetup && partnerDomainSetup !== "us") {
      region = partnerDomainSetup;
    } else {
      console.log("List error:: partnerDomainSetup missing", partnerDomainSetup);
    }
    PartnerDashboardService.getPartnerAppsList(region, true)
      .then((response) => {
        setIsLoading(false);
        if (response && response.data) {
          setApps(response.data);
        }
        if (response.data.length == 0) {
          setHideListApps(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const editPartner = (app, stage, isView) => {
    console.log("Edit App in parent", app, stage, isView);
    appEdit(app, stage, isView);
  };

  useEffect(() => {
    console.log("ListBase Mount");
    getApps();

    return () => {
      console.log("ListBase Destroy");
    };
  }, []);

  return (
    <div className="apps-section">
      <div className="apps-list">
        {!isLoading && apps && apps.length ? (
          <>
            <Flex style={{ "margin-top": "24px" }}>
              <Heading size="section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.your-apps-text")}</Heading>
            </Flex>
            <Flex style={{ "margin-top": "16px" }} direction="horizontal" wrap="true" justify="flex-start" gap={40}>
              <ListApps appActivationMap={activationMap} mtcAppAllowed={mtcAppAllowed} copyAppFn={copyAppFn} apps={apps} appEdit={editPartner} resetList={resetList} />
            </Flex>
          </>
        ) : (
          <div className="apps-loader">
            <MSpinner size="md" />
          </div>
        )}
      </div>
    </div>
  );
}

export default ListBase;
